import { LOCALSTORAGE_KEYS } from '@constants';
import { atom, AtomEffect, selector } from 'recoil';
import { Account } from 'types/Account';
import { localStorageEffectNumber } from './effects';

const PREFIX_KEY = 'src/atoms/common/';

function calculateFields({
  onSet,
  setSelf,
}: Parameters<AtomEffect<Account[] | undefined>>[number]): ReturnType<
  AtomEffect<Account[] | undefined>
> {
  onSet((newValue) => {
    setSelf(
      newValue?.map((account) => ({
        ...account,
        displayName: account.custom?.accountName || account.tradeName,
      })),
    );
  });
}

export const accountsAtom = atom({
  key: `${PREFIX_KEY}accounts.atom`,
  default: undefined,
  effects: [calculateFields],
});

export const accountIdSelectedAtom = atom<number | null>({
  key: `${PREFIX_KEY}account-id-selected.atom`,
  default: null,
  effects: [localStorageEffectNumber(LOCALSTORAGE_KEYS.ACCOUNT_ID_SELECTED)],
});

// null means all accounts
export const accountSelectedSelector = selector({
  key: `${PREFIX_KEY}account-selected.selector`,
  get: ({ get }) => {
    const accounts = get(accountsAtom);
    const accountIdSelected = get(accountIdSelectedAtom);

    if (!accounts) {
      return null;
    }

    if (accounts.length === 1) {
      return accounts[0];
    }

    if (!accountIdSelected) {
      return null;
    }

    return accounts.find((account) => account.id === accountIdSelected) || null;
  },
});
